import React from "react"
import { Link } from "gatsby"

import Layout from "../../../components/layout"
import { FooterAlternate1 } from "../../../components/footer"
import SEO from "../../../components/seo"

const IndexPage = () => (
    <Layout>
      <SEO title="Sales people - are you headed in the wrong direction?" />

      <nav className="share-bar">
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/sales-people-are-you-headed-wrong-direction/&amp;title=Sales%20people%20%20-%20are%20you%20headed%20in%20the%20wrong%20direction%3F&amp;summary=Sales%20people%20%20-%20are%20you%20headed%20in%20the%20wrong%20direction%3F&amp;source=https%3A//salestribe.com/knowledge-centre/insights/sales-people-are-you-headed-wrong-direction/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-linkedin-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Sales%20people%20%20-%20are%20you%20headed%20in%20the%20wrong%20direction%3F&amp;url=https%3A//salestribe.com/knowledge-centre/insights/sales-people-are-you-headed-wrong-direction/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-twitter-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/sales-people-are-you-headed-wrong-direction/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon">
                    <svg width="26" height="26">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-googleplus-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/sales-people-are-you-headed-wrong-direction/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon">
                    <svg width="22" height="22">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-facebook-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Sales%20people%20%20-%20are%20you%20headed%20in%20the%20wrong%20direction%3F&amp;body=https%3A//salestribe.com/knowledge-centre/insights/sales-people-are-you-headed-wrong-direction/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon">
                    <svg width="20" height="20">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-email-badge"></use>
                    </svg>
                </span>
            </Link>
        </li>
    </ul>
</nav>

<article className="article">

    

<header className="header header--article article__header" id="page-header">
    <div className="header__image" >
        <div className="header__bgimage" style={{backgroundImage: "url(../../../media/images/article-success-arrow-climb.2e16d0ba.fill-1162x655.jpg)"}}></div>
        <div className="header__video">
            <div className="embed-responsive embed-responsive-16by9"></div>
        </div>
    </div>
    <div className="header__content">
        <div className="container">
            <div className="row">
                <div className="header__inner col-md-7 col-lg-offset-1">
                    <Link to="knowledge-centre/insights/" className="header__back back-link">
                        <span className="sr-only">Back to all articles</span>
                        <i className="icon"></i>
                    </Link>
                    <div className="header__title">
                        <h3>B2B Sales</h3>
                        <h1>Sales people  - are you headed in the wrong direction?</h1>
                    </div>
                    <ul className="post-meta-list">
                        <li>by Graham Hawkins</li>
                        <li>25 February 2016</li>
                        <li>3 min read</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</header>


<div className="container" id="article-content">
    <div className="row">
        <div className="article__body col-sm-12 col-md-8 col-lg-offset-1 col-lg-7 wysiwyg">
            
<h3>Buyers now have greater leverage than ever before - what does that mean for sales people:</h3>

<div className="rich-text"><p>As outlined in my previous posts, the balance of power has now shifted from vendors to customers, and we are now seeing a new era where the highly sought after customers call the shots – especially at the ‘enterprise’ end of town. This is a big turnaround from when I first began my career in IT sales when vendor innovation was responsible for driving markets. Nowadays, it is the increasing power of highly educated and sophisticated IT buyers that has the leverage to insist that vendors provide them with increasing <em>value-add</em> – both pre and post-sale. This now comes in the form of a high touch, ‘<em>arms around’</em> experience, and vendor sales people whom fail to offer their customers these improved levels of handling and attention will be increasingly outperformed by those vendors that are prepared to listen to their customers and make the necessary changes.</p><p>Whether sales people like it or not, IT buyers can now demand increasingly higher levels of service and value-add from each of their vendors at every step along the <em>new buying journey</em>, and yet I’m amazed to see such a large percentage of the vendors operating today that remain wedded to their legacy <em>modus operandi</em> which requires the sales person to effectively foster a <em>“churn and burn”</em> mentality. The relentless, and blinkered pursuit of new ‘logos’ simply overlooks the increasing importance of <em>'retention'</em> strategies, and new and <em>extended buying journey</em>.</p></div>
<img alt="New Buying Journey" className="img-responsive" height="268" src="../../../media/images/AAEAAQAAAAAAAAh8AAAAJDgxMmQxZjM5LThlZTgtNDZjZC.width-647.png" width="647"/>

<div className="rich-text"><p>In November, 2011, Wood, Hewlin &amp; Lah co-authored a wonderfully insightful book entitled <em>Consumption Economics: The New Rules of Tech</em>. This publication speaks directly to my point about the impending death of legacy vendor models in these modern times of cloud computing and the new customer-led economy. Winners and losers in this space will be shaped by the organisational decisions made by vendors in the next 2-4 years. As pointed out by Wood et al (2011), vendors must soon make the hard decisions to move away from the short term financial performance focus that drives their share price and the associated self-interests of senior management executives. Quite rightly, customers now demand a ‘risk shift’ and the expectation is that vendors must become increasingly more flexible in the way that they license and sell their products in the future. If you are seeking a successful career in B2B technology sales, and you have not read this book, then I contend that you are behind the game:</p><p>All of this change simply means that vendor sales people are now under pressure to change direction and move away from legacy pricing models (and the associated revenue streams) and re-think their commercial models in order to accommodate the growing number of IT buyers that are demanding increased flexibility. Many of the traditional approaches to licensing IT products allowed the vendor to charge the customer the full amount up-front in return for a perpetual '<em>right to use'</em> the software. Most software vendors also offer annual maintenance &amp; support which creates (in some cases) a lucrative annuity revenue stream for the vendor and very little value for the customer. This legacy model clearly favours vendors, allowing full revenue capture and recognition up front, regardless of how often the customer actually utilizes the product or support services in the future, or whether the product or service ever delivers the level of value that the vendor had promised during sales pitch.</p><h3><strong>So What?</strong></h3><p>Times are changing rapidly for sales people. Vendors no longer have the power, and the role of the B2B sales person continues to evolve into new directions. Customers are no longer required to submit to vendor <em>“lock in”</em> when there are so many alternative or substitute products now available. Nor are customers willing to continue to buy into legacy sales models that require them to assume all the risk. Sales people that fail to listen to their customers and take a longer term view of the relationship will face a future outlook that is based around negative growth and declining revenues. Hence, sales leaders must now ensure that they have the right customer engagement models in place that will address these important changes, and produce positive customer experience that will foster and facilitate repeat business.</p></div>


        </div>
            
        <aside className="article__sidebar col-sm-12 col-md-4 col-lg-offset-1 col-lg-3">
            <div className="article__sidebar-wrap" id="article-sidebar">
                <div className="card card--profile">
                        
<div className="card__header">
    <div className="card__image">
        <img alt="Mentor Thumb Graham Hawkins" className="img-responsive" height="165" src="../../../media/images/Mentor-Thumb-Graham-Hawkins.2e16d0ba.fill-165x165.jpg" width="165"/>
    </div>
    <div className="card__title">
        <h4>Graham Hawkins</h4>
        <p>SalesTribe Mentor</p>
        <Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-md hidden-lg">View full profile</Link>
    </div>
</div>
<div className="rich-text"><p>With more than twenty-eight years of business experience in
executive B2B sales and sales leadership roles, Graham is a highly experienced
and versatile business executive with proven strengths in strategic business
development, go-to-market planning and sales and marketing.</p><p><br/></p><p><br/></p></div>
<Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-xs hidden-sm">View full profile</Link>

                </div>
                <nav className="social-nav">
    <h4>Share</h4>
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/sales-people-are-you-headed-wrong-direction/&amp;title=Sales%20people%20%20-%20are%20you%20headed%20in%20the%20wrong%20direction%3F&amp;summary=Sales%20people%20%20-%20are%20you%20headed%20in%20the%20wrong%20direction%3F&amp;source=https%3A//salestribe.com/knowledge-centre/insights/sales-people-are-you-headed-wrong-direction/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon icon-linkedin"></span>
                
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Sales%20people%20%20-%20are%20you%20headed%20in%20the%20wrong%20direction%3F&amp;url=https%3A//salestribe.com/knowledge-centre/insights/sales-people-are-you-headed-wrong-direction/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon icon-twitter"></span>
                
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/sales-people-are-you-headed-wrong-direction/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon icon-google-plus"></span>
                
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/sales-people-are-you-headed-wrong-direction/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon icon-facebook-f"></span>
                
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Sales%20people%20%20-%20are%20you%20headed%20in%20the%20wrong%20direction%3F&amp;body=https%3A//salestribe.com/knowledge-centre/insights/sales-people-are-you-headed-wrong-direction/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon icon-envelope"></span>
                
            </Link>
        </li>
    </ul>
</nav>

            </div>
        </aside>
            
    </div>
</div>
</article>

<div className="block block--grey related-items">
    <div className="related-items__wrap">
        <div className="container">
            <div className="row" data-tablet-slick>
                
        <article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-complete-waste-money-and-time-part-2" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">5 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>Sales Training’ is a waste of money and time (Part 2)</strong></h3>
                    </header>
                    <p>We must stop teaching sales people how to ‘push’ buyers, and instead start training and coaching them on how to become highly specialised teachers.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-waste-time-and-money-part-1" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">4 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>‘Sales Training’ is a waste of time and money (Part 1)</strong></h3>
                    </header>
                    <p>When you teach sales people how to ‘push’ buyers through a sales playbook you are teaching them how to destroy your business reputation.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/b2b-sales-has-changed-about-180-degrees" className="card card--article">
                <div className="card__thumb">
                    <img alt="Mentor Large Graham Hawkins" className="card__image" height="404" src="../../../media/images/Mentor-Large-Graham-Hawkins.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">04:28</span>
                    <span className="card__icon play-icon">
                        <i className="icon"></i>
                    </span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>B2B Sales has changed about 180 Degrees!</strong></h3>
                    </header>
                    <p>B2B sales has now changed so dramatically that it&#39;s a &quot;profession&quot; that is barely recognisable to the role that both Tony Hughes and Graham Hawkins began about 30 years ago - respectively.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article>

            </div>
            <div className="load-more">
                <Link to="knowledge-centre/insights/" className="btn btn-link">Browse more insights</Link>
            </div>
        </div>
    </div>
</div>
      
      <FooterAlternate1 />

    </Layout>
)

export default IndexPage 